import React, { useEffect, useState } from "react";
import "./index.scss";
import { thirdData, fourthData } from "./constants";
import Title from "../../components/Title";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { customerServiceInfo } from "../../utils/api";

const Home = () => {

  const [customerServiceInfoData, setCustomerServiceInfoData] = useState<any>(null);
  // const onDownload = () => {
  //   window.location.href = "https://app.adjust.com/1wadk7co"
  // };

  useEffect(() => {
    const getCustomerServiceInfo = async () => {
      const res: any = await customerServiceInfo({});
      if(res?.mxfj === '200') {
        setCustomerServiceInfoData(res?.parseObj);
      }
    };
    getCustomerServiceInfo();
  }, []);
  return (
    <div className="pit-home-container-pc">
      <div className="first">
        <Header variant="light" />
        <div className="main">
          <div className="left">
            <Title className="f-title" type="1">
              Préstamos al instante, sin buró
            </Title>
            <div className="desc">
              <div>
                Pitage: préstamos rápidos, confiables y diseñados para impulsar
                tu tranquilidad financiera.
              </div>
              {/* <div>Más de <span className="desc-money">1,000,000</span> de clientes han</div>
              <div>confiado en nosotros para construir su</div>
              <div>libertad financiera</div> */}
            </div>
            <a
              className="google-play"
              href="https://app.adjust.com/1wadk7co"
              target="_blank"
              rel="noreferrer"
              aria-label="google play"
            ></a>
          </div>
          <div className="bg" />
        </div>
      </div>
      <div className="second">
        {/* <div className="bg" /> */}
        <div className="right">
          <Title className="s-title">Nuestro ventaja</Title>
          <div className="desc">
            <div>
              Préstamo online hasta <span>$1.800.000</span> rápido y seguro
            </div>
            <div>Los intereses más bajos del mercado competitivos</div>
            <div>
              Cuotas bajas y flexibles, hasta 365 días de plazo Evaluación y
              préstamos en solo 3 minuto
            </div>
          </div>
        </div>
      </div>
      <div className="third">
        <Title className="t-title">Proceso de solicitud</Title>
        <div className="desc">
          El proceso de operación es simple y conveniente, y la solicitud en
          línea se puede completar en tan solo 3 minutos.
        </div>
        <div className="bg">
          {thirdData.map((item) => (
            <div className="icon-wrapper" key={item.icon}>
              <div className={`icon ${item.icon}`}></div>
              <div>{item.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="fourth">
        <Title className="fo-title">Experiencia de nuestros clientes</Title>
        <div className="desc">
          Nuestro objetivo es proporcionar los mejores productos y servicios a
          los usuarios y actualmente hemos recibido verdaderos elogios de muchos
          usuarios.
        </div>
        <div className="bg">
          {fourthData.map((item) => (
            <div className="bg-inner" key={item.title}>
              <div className="bg-title">{item.title}</div>
              <div className="bg-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="fifth">
        <Title className="fi-title">Contacto</Title>
        <div className="main">
          <div className="bg">
            <div className="bg-inner">
              <div className="icon mail"></div>
              <div>{customerServiceInfoData?.jhzou}</div>
            </div>
            <div className="bg-inner">
              <div className="icon time"></div>
              <div>Lun-Sáb 8:30-18:00</div>
            </div>
            <div className="bg-inner">
              <div className="icon whatsapp"></div>
              <div>Whatsapp: {customerServiceInfoData?.alzgdzqq}</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
